export default __webpack_public_path__ + "static/media/avatar-2.c9d9b0ca.jpg";